import MergeDocumentations from './mergedocumentations'

export default MergeDocumentations